/**
 * Values shared across the lab screens.
 *
 * These used to live at the top of a single 2,192-line `App.tsx`. They are kept in one
 * small module rather than re-exported from a screen so that importing, say, the settings
 * screen does not drag the whole application in with it.
 */
export const DEMO = import.meta.env.VITE_DEMO_MODE === 'true';

/** Command statuses that mean work is still in flight, so controls stay disabled. */
export const activeStatuses = [
  'QUEUED',
  'RUNNING',
  'WAITING_WORKER',
  'PAUSED_BUDGET',
  'PAUSED_QUOTA',
  'RECONCILIATION',
];

/** Turns a SCREAMING_SNAKE status into human-readable text. */
export const label = (text: string) =>
  text
    .toLowerCase()
    .replaceAll('_', ' ')
    .replace(/^./, (c) => c.toUpperCase());
